module.exports = __webpack_public_path__ + "media/application/images/ui/join-home-close-70fb40235066b02205f1fe82b9a7853f.jpg";